import { Item } from "@/tools/msa/models/item";
import { getPages } from "@/tools/msa/utils/export";

const fallbackArray = <T>(array: T[], fallback: T[]) =>
  array.length > 0 ? array : fallback;

export const calculateDates = (item: Item): string[] =>
  item.type === "code_match"
    ? [
        item.match.refers.dates,
        getPages(item)
          .map(page => page.date!)
          .filter(Boolean),
        [item.document.date].filter(Boolean).map(date => date as string),
        []
      ].reduce((a, b) => fallbackArray(a, b), [])
    : item.type === "msa_custom"
    ? [item.date]
    : [];
